import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface UseScrollToTopOptions {
  behavior?: 'smooth' | 'auto';
}
export const useScrollToTop = (options: UseScrollToTopOptions = {}) => {
  const location = useLocation();
  const { behavior = 'auto' } = options;

  useEffect(() => {
    // Scroll to top when location changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior
    });
  }, [location.pathname, behavior]);
}; 